import { isSaasTelemetryEnabled } from '@/utils/buildProfile';
import { useEffectiveSessionTimeout } from '@heidi/workspace/data';
import posthog from 'posthog-js';

import { resolveTimeToLogout } from './sessionTimeout';

// TELEMETRY-GATE: the PostHog half of `resolveTimeToLogout` is the legacy
// MUL-1879 fallback, and `getFeatureFlagPayload` on a client whose `init` the
// provider short-circuited answers for a flag set that was never fetched. A
// build with the telemetry axis off reads the backend value only.
const NO_FLAG_PAYLOADS: Pick<typeof posthog, 'getFeatureFlagPayload'> = {
  getFeatureFlagPayload: () => null,
};

/**
 * The idle-logout timeout `AutoLogout` enforces, in minutes, or `null` when no
 * timeout applies and the component must not mount.
 *
 * Its own module so `UniversalGlobalModals` can mount `AutoLogout` on every
 * build without taking a value-level `posthog-js` import: the backend branch
 * (`GET /user` → `session_timeout`) is the one that resolves on-prem, and it is
 * preferred over the fallback anyway.
 */
export function useTimeToLogout(): number | null {
  const sessionTimeout = useEffectiveSessionTimeout();

  return resolveTimeToLogout(
    sessionTimeout,
    isSaasTelemetryEnabled ? posthog : NO_FLAG_PAYLOADS
  );
}
